import { FavoriteTenders } from './FavoriteTenders';
import { CabinetLayout } from '@web-kc/shared/components';

import { useTranslation } from 'next-i18next';

export function FavoriteLotsCabinetPage() {
  const { t } = useTranslation();

  return (
    <CabinetLayout pageTitle={t('common:pageTitle.cabinet.favorite-lots')}>
      <FavoriteTenders type="lots" />
    </CabinetLayout>
  );
}
